import React from 'react';
import './basicHeader.scss';
import logo from '../../images/spotlightLogo.svg'

class BasicHeader extends React.Component {



    render() {
        return (
            <header >
                <div className="container" >
                    <div id="branding">
                        {/* <img src="https://www.talsup.com/static/images/talsup-logo.png" alt="" className="showcaseBranding" /> */}
                        <img src={logo} alt="" className="showcaseBranding" />

                    </div>
                </div>
            </header>
        );
    }
}

export default BasicHeader;